<template>
  <tr
    tabindex="0"
    class="not-read">
    <td>
      <promise-link
        :promise="props.item.ref"
        router-name="CaseChannelsList"
        router-path="caseId"
        promise-key="code" />
    </td>
    <td class="text-center">
      {{ props.item.insertedAt }}
    </td>
    <td class="text-center">
      <term-download v-if="props.item.refusalCertificate" :file="props.item.refusalCertificate" />
    </td>
  </tr>
</template>

<script>
  import PromiseLink from '@/components/ui/PromiseLink'
  import TermDownload from '@/components/ui/TermDownload'

  export default {
    components: { PromiseLink, TermDownload },
    props: {
      props: {
        type: Object,
        default: () => ({})
      }
    }
  }
</script>
